import Image from "next/image"
import styles from "../upsc-prestorming-prelims-test-series-thankyou/thankyou.module.css";
import NewiconA from "../../assets/images/header/modalnew.png";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import Link from "next/link";
import thankyou from "../../assets/images/upsc/thank you.png";

const allIndiaPrelims = () => {
   
    return (
        <>
        <Navbar title="upsc" />
            <div className="container-fluid " style={{backgroundColor:"#F4F6F8"}}>
                <div className="row">
                    <div className="col py-5 my-md-3">
                        <div className="container">
                            <div className="row">
                                <div className="col px-0 text-center py-5">
                                    <Image src={thankyou} className="img-fluid " alt="Thank you" title="Thank you"/>
                                    <p className={`${styles.thankspara} pt-3`}>Thank you for registering with us.<br/> We will get back to you soon.</p>

                                           
                                    <Link href="/all-india-upsc-prelims-mock-test"><button className={`${styles.normalbutton}`} >Back</button></Link>
                                    
                                </div>

                                <div className="">  
                                     <p className={`${styles.aboutparagraph3} p-1`}><Link href="/upsc-prelims-hallticket" rel="noreferrer" target="_blank" className={`${styles.program}`}><span><Image src={NewiconA} width="20" height="20" alt="New_icon" className="img-fluid mx-2" /></span> Download UPSC Prelims Mock Test Hall Ticket (Click Here)  </Link></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>          
        <Footer />

        </>
    )
}

export default allIndiaPrelims